export { useInvestmentAssumptionContext } from '../context'
